var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogotypeSqBDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3854.5924,
    height: 871.5,
    viewBox: "0 0 3854.5924 871.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #d01600;\n        opacity: 0.5;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: #ff1717;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 357.5,
    y1: -30.0786,
    x2: 357.5,
    y2: 772.9497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3e4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2794,
    stopColor: "#393a46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5837,
    stopColor: "#2e3038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8988,
    stopColor: "#1d1e23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    stopColor: "#1c1d21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 310.6104,
    y1: 316.4409,
    x2: 532.7755,
    y2: 316.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7adefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1148,
    stopColor: "#7ac2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3114,
    stopColor: "#7b98fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#7b77fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6856,
    stopColor: "#7c5ffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    stopColor: "#7c51fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c4cfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 211.998,
    y1: 372.8713,
    x2: 532.7755,
    y2: 372.8713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77defe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1148,
    stopColor: "#78c2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3114,
    stopColor: "#7998fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#7b77fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6856,
    stopColor: "#7b5ffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8555,
    stopColor: "#7c51fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c4cfd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 715,
    height: 715,
    rx: 160
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2349.6142,576.8769l-.1289.558c.062-.2067.1255-.41.187-.6171C2349.6528,576.8375,2349.6332,576.8572,2349.6142,576.8769Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M958.608,358.5c0-212,136-347,338-347,177,0,286,98,310,264h-176c-14-68-58-108-128-108-90,0-132,60-132,180v20c0,120,41,180,128,180,75,0,120-36,132-125h180c-13,197-141,281-318,281C1090.608,703.5,958.608,569.5,958.608,358.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1671.6022,21.5h189v668h-189Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1941.5958,26.5h191v141h-191Zm2,191h188v472h-188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2212.589,217.5h189v58c30-44,78-71,140-71,122,0,208,100,208,247v1c0,149-85,250-209,250-58,0-107-27-139-70v235h-189Zm339,242v-14c0-81-27-112-76-112-54,0-76,41-76,107v28c0,65,21,105,76,105C2523.589,573.5,2551.589,539.5,2551.589,459.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2812.5851,217.5h189v58c30-44,78-71,140-71,122,0,208,100,208,247v1c0,149-85,250-209,250-58,0-107-27-139-70v235h-189Zm339,242v-14c0-81-27-112-76-112-54,0-76,41-76,107v28c0,65,21,105,76,105C3123.5851,573.5,3151.5851,539.5,3151.5851,459.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3371.5924,741.5h77c36,0,53-3,66-52l-183-472h197l92,283,85-283h149l-177,518c-34,92-88,136-203,136h-103Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.0626,431.9674a39.7094,39.7094,0,0,0,3.9456.82c1.3274.21,2.6641.3594,4.0012.4653q3.3387.2645,6.5994.2232a75.9361,75.9361,0,0,0,34.78-9.2046q3.7647-1.9791,7.4254-4.3262,2.3721-1.5176,4.651-3.1768c1.1662-.8481,2.3143-1.7187,3.43-2.6245,1.4919-1.2119,2.9375-2.4721,4.3071-3.8012q1.1181-1.0856,2.1719-2.2261a48.6856,48.6856,0,0,0,3.9111-4.8071c.1182-.1665.2314-.3365.3494-.503q2.1831-3.0856,4.3116-6.21,2.2219-3.2571,4.392-6.5518l96.1068-140.81q.9-1.2135,1.798-2.4292.8708-1.1843,1.7336-2.3745c.93-1.2763,1.8613-2.5522,2.7808-3.8359l.0019-.0024.0017.01.1708-.2539.0419-.0591q3.4571-4.8318,6.7871-9.748c.2893-.4268.582-.8516.87-1.2793q1.5453-2.2955,3.0542-4.6157.4164-.6387.83-1.2793,1.5736-2.4324,3.1123-4.8877l12.1489-19.08L502.661,223.0074q-15.6273,10.9586-31.55,21.4985c-21.1277,13.9873-42.8606,26.9707-64.635,39.8916-16.3172,9.6822-32.8824,18.9488-49.15,28.712-12.7339,7.6425-23.9624,16.9179-31.8806,29.9243-8.8345,14.5112-14.2376,29.9013-14.6563,46.9712a368.2275,368.2275,0,0,0,.7583,38.8965,28.7344,28.7344,0,0,0,5.5794,2.4946Q318.087,431.711,319.0626,431.9674Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M520.6266,217.48q-1.5338,2.4591-3.1123,4.8877-.4142.64-.83,1.2793-1.5132,2.3174-3.0542,4.6157c-.2879.428-.5806.8525-.87,1.2793q-3.3318,4.9156-6.7871,9.748l-.0419.0591-.1708.2539-.0017-.01-.0019.0024c-.92,1.2835-1.85,2.5594-2.7808,3.8357q-.8654,1.188-1.7336,2.3748-.8952,1.2169-1.798,2.4292l-96.1068,140.81q-2.1753,3.29-4.392,6.5517-2.1273,3.1252-4.3116,6.21c-.118.1665-.2312.3365-.3494.503a48.6856,48.6856,0,0,1-3.9111,4.8071q-1.0525,1.1415-2.1719,2.2261c-1.37,1.3291-2.8152,2.5893-4.3071,3.8012-1.1153.9058-2.2634,1.7766-3.43,2.6245q-2.2768,1.656-4.651,3.177-3.6617,2.3424-7.4254,4.326a75.9363,75.9363,0,0,1-34.78,9.2048q-3.2611.0388-6.5994-.2234c-1.3371-.1057-2.6738-.2558-4.0012-.4651a39.7672,39.7672,0,0,1-3.9456-.82q-.975-.2568-1.9355-.5713a28.7241,28.7241,0,0,1-5.58-2.4946,29.2413,29.2413,0,0,1-2.95-1.1822c-24.7437-13.06-34.649-41.8088-29.4656-66.2693,4.1086-19.3872,12.6318-37.2639,19.5219-55.6845,6.3179-16.8926,13.3687-33.51,19.9971-50.2879q9.4933-24.0315,18.7639-48.1513c1.4229-3.7227,2.9153-7.4224,4.4239-11.1167,5.1416-12.59,10.4856-25.1143,14.03-38.2322q.3808-1.4093.7014-2.81a53.2012,53.2012,0,0,0-1.2034-28.5857l-.0481-.1438a75.4071,75.4071,0,0,0-14.8112-25.4937,60.3744,60.3744,0,0,0-5.2141-5.3032l-.06-.0527a71.639,71.639,0,0,0-35.7322-16.44A77.7447,77.7447,0,0,0,262.89,80.7687c-1.88.6145-3.7192,1.3166-5.5271,2.0815-.166.07-.3357.1324-.501.2039-.0427.0171-.0849.0359-.1267.0532a46.0234,46.0234,0,0,0-4.4165,2.1226,76.3262,76.3262,0,0,0-24.0017,19.7373c-.0237.0268-.0486.0542-.072.081q-.579.6677-1.1358,1.34a54.9908,54.9908,0,0,0-8.9682,15.364c-5.0354,11.3125-6.9253,23.6589-5.8526,36.8821,2.2061,27.1975,14.7813,49.2949,34.8587,67.3779a.8548.8548,0,0,0,1.3059.0893,19.9267,19.9267,0,0,0-.0086-2.0127,148.1015,148.1015,0,0,1,.7935-36.0981c1.366-9.3438,2.9006-18.6606,6.1626-27.5361,4.2483-11.5586,7.8926-23.4883,18.8452-31.1294,6.2151-4.3362,12.8853-5.9556,20.0911-4.2881,6.6682,1.543,11.37,5.6015,12.62,12.7734a31.4694,31.4694,0,0,1-1.833,17.0462q-11.5793,29.6692-23.4241,59.2346c-10.9084,27.2554-22.0906,54.4028-32.8171,81.7295-6.3714,16.2314-13.8074,32.0947-18.0283,49.1172-2.9976,12.09-4.6685,24.3493-3.2889,36.8047,1.7376,15.684,5.4,30.8476,12.94,44.8994a102.2543,102.2543,0,0,0,14.3208,20.9187,111.9255,111.9255,0,0,0,32.3264,24.1911c19.9622,10.1988,40.8553,12.2691,62.5726,8.718,2.64-.4318,3.206.11,3.68,2.4175,2.9888,14.5518,6.19,29.06,9.1431,43.6189q9.6547,47.5825,19.1189,95.204c2.594,13.0553,5.6829,26.0189,7.3721,39.2494.31,2.4289.1445,4.9956,1.3571,7.7019,1.4671-10.8524,2.7571-21.2587,4.3094-31.6255,1.45-9.6843,3.6662-19.2788,4.62-29.0037.6809-6.94,2.1309-13.7395,3.0855-20.6076.9192-6.6138,2.5159-13.2393,3.3608-19.8726,1.1446-8.98,3.0183-17.8379,4.6323-26.6938,1.96-10.7549,3.7269-21.554,5.6231-32.32,2.8989-16.46,5.3027-33.01,7.7834-49.5413a7.0689,7.0689,0,0,1,3.139-4.7937c4.6274-3.6445,9.33-7.2319,13.6474-11.2263,13.8462-12.81,22.5928-29.1035,30.8521-45.729,9.4607-19.0442,17.6042-38.6577,25.289-58.4593,3.0247-7.7939,5.6433-15.7507,8.2281-23.71,2.4067-7.4109,6.1123-19.6086,8.2592-27.0988,3.1206-10.8855,6.3728-21.7447,9.0784-32.7359.7937-3.2241,1.532-6.46,2.2483-9.7007L532.7755,199.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.48,404.6319c.2287-.2182.3681-.3486.368-.3486C402.1717,404.8155,402.1254,404.8814,402.48,404.6319Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeSqBDark);
export default __webpack_public_path__ + "static/media/logotype-sq-b-dark.6fde21a77bc58e304f17213e4b0d794f.svg";
export { ForwardRef as ReactComponent };